import React from "react";

import CardBody from "../../../components/Card/CardBody";
import Card from "../../../components/Card/Card";
import { GridLegacy } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import Divider from "@mui/material/Divider";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";

function SubsResellerGeneral() {
  let infoFields = ["description"];

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <GridLegacy item sm={6} xs={12}>
            <h3>
              <TranslationWrapper tKey={"Reseller information"} />
            </h3>
          </GridLegacy>

          {infoFields.map((fieldKey) => {
            return <FormTextTC name={fieldKey} tDefault={fieldKey} tKey={"subsReseller." + fieldKey} />;
          })}

          <FormSwitchTC name={"transactionKickback"} tDefault={"Transaction kickback"} tKey={"subsReseller.kickback"} />

          <FormAsyncTC
            async={{
              url: "core/subsDebtor/search?fields=id as value, company_name as label&per_page=30",
              searchField: "company_name",
            }}
            name={"subs_debtor_id"}
            tDefault={"Debtor"}
            tKey={"subsReseller.debtor"}
          />
        </GridLegacy>
        <Divider />
      </CardBody>
    </Card>
  );
}

export default SubsResellerGeneral;
